import { action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore from 'stores/BaseStore';

class SiteStore extends BaseStore {
  constructor() {
    super('sites', 'site');
  }

  @action getFields(site) {
    return HttpClient.get(`${config.api}/site/${site}/getFields`)
      .then(action(response => {
        return response.data.filter(field => field.group === 'Custom Fields');
      }));
  }

  async checkPartner(data) {
    return await HttpClient.post(`${config.api}/site/check-partner`, data)
      .then(response => {
        return response.data
      })
  }
}

export default new SiteStore();
